import React from 'react';
import { FiLoader } from 'react-icons/fi';

const Loader:React.FC = () => {
  return (
    <FiLoader className="animate-spin mx-2" />
  );
}

export default Loader;
